<app-subscriber-group-counter-chart
  [subscriberGroupCounters]="subscriberGroupCounters"
  [graphType]="graphType"
  [subscriptionTypes]="subscriptionTypes"
  [responsive]="responsive"
  [width]="width"
  [height]="height"
/>
